import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  gatewayFormValidatorWithCustomErrors,
  VALIDATORS,
} from "../../../../utils/gatewayFormValidator";
import { Form, Button } from "react-bootstrap";
// import QRCodeCard from "../../../../utils/QrCodeCard";
import QRCodeCard from "../../../../utils/QrCodeCard";
import {
  updateDepositAmount,
  createDeposit,
  getOneGatewayDetails,
} from "../../../../redux/user/actions";
import { APP_CONST } from "../../../../config/const";
import { Toaster } from "../../../../utils/toaster";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import Footer from "../../../../containers/Footer";
import { Container } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { getActiveBankDetails } from "../../../../redux/app/actions";
// import CopyToClipboard from "../../../components/copyToClipBoard";
import CopyToClipboard from "react-copy-to-clipboard";
import LeftArrow from "../../../../assets/images/icons/back.png";

import ArrowNext from "../../../../assets/images/arrow-next.png";
import Attention from "../../../../assets/images/attention.png";

import { AiFillCopy } from "react-icons/ai";
import LeftBarSports from "../../../components/LeftBarSports";
import WhatsAppWidget from "../../../components/WhatsAppWidget";
import numberWithCommas from "../../../../utils/numbersWithComma";

import CrossBtn from "../../../../assets/images/icons/close_btn-icon.png";
import DisplayValues from "../../../components/gateways/displayValues";

const CUSTOM_DEPOSIT_RESPONSE_TYPE = {
  QRCODE: "QRCODE",
  IMAGE: "IMAGE",
};

const DepositGateway = () => {
  const [selectedGateway, setSelectedGateway] = useState(null);
  const { bankDetails } = useSelector((state) => state.app);
  const dispatch = useDispatch();
  const { appDetails } = useSelector((state) => state.app);
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const { gateway } = useParams();
  const isBank = gateway === "bank_transfer";
  const showQrImg = selectedGateway?.qrCode !== null;
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(null);
  const inputRef = useRef(null);
  const [dAmount, setDAmount] = useState(null);
  const [customdepositResponseType, setCustomDepositResponseType] =
    useState(null);
  const [customActionDepositResponse, setCustomActionDepositResponse] =
    useState(null);
  const [loading, setLoading] = useState(false);
  const [isCreatingDeposit, setIsCreatingDeposit] = useState(false);

  const amountValues = [1000, 5000, 10000, 50000, 100000, 500000];

  useEffect(() => {
    dispatch(getActiveBankDetails());
    if (gateway !== "bank_transfer") {
      getOneGtwFromServer(gateway);
    }
  }, [gateway]);

  const getOneGtwFromServer = async () => {
    const response = await getOneGatewayDetails({ id: gateway });
    if (response && response?.data?.data) {
      setSelectedGateway(response?.data?.data?.data);
    }
  };

  const validateData = (dataToValidate) => {
    const amountValidation = [];

    if (selectedGateway?.depositSettings?.min) {
      amountValidation.push({
        validationValue: selectedGateway?.depositSettings?.min,
        type: VALIDATORS.Min,
        customMessage: `Min allowed amount is ${selectedGateway?.depositSettings?.min}`,
      });
    }

    if (selectedGateway?.depositSettings?.max) {
      amountValidation.push({
        validationValue: selectedGateway?.depositSettings?.max,
        type: VALIDATORS.Max,
        customMessage: `Max allowed amount is ${selectedGateway?.depositSettings?.max}`,
      });
    }
    let fields = selectedGateway.fields;
    let validations = gatewayFormValidatorWithCustomErrors({
      fields,
      dataToValidate,
      cstmValidation: { amount: amountValidation },
    });
    setErrors(validations);
    return validations;
  };

  const validateBankFormData = (data) => {
    const { amount, utrNo, txnImage } = data;
    let errorVar = {};
    if (!amount) {
      errorVar.amount = "Amount is required";
    }
    if (!utrNo) {
      errorVar.utrNo = "UTR is required";
    }
    if (!txnImage) {
      errorVar.txnImage = "Txn image is required";
    }
    setErrors(errorVar);
    return errorVar;
  };

  const handleChange = (e, type = "non-file") => {
    let name = e.target.name;
    let value = e.target.value;
    if (type === "file") {
      value = e.target.files?.[0];
    }
    let data = { ...formData, [name]: value };

    if (isBank) {
      validateBankFormData(data);
    } else {
      validateData(data);
    }

    setFormData(data);
  };

  const getIfDefaultValue = ({ data }) => {
    let updatedData = { ...data };
    selectedGateway?.fields.forEach((f) => {
      if (!Boolean(data[f?.accessor]) && Boolean(f?.value)) {
        updatedData[f?.accessor] = f?.value;
      }
    });
    return updatedData;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isBank) {
      if (Object.values(validateData({ ...formData })).length == 0) {
        setIsCreatingDeposit(true);
        if (
          selectedGateway?.fields.some(
            (f) => f?.accessor === "gateway" && f?.required === true
          )
        ) {
          formData["gateway"] = selectedGateway?.code;
        }
        if (selectedGateway?.slug && selectedGateway?.slug !== null) {
          formData.slug = selectedGateway?.slug;
        }

        const dataWithDefaultValues = getIfDefaultValue({ data: formData });

        const response = await updateDepositAmount({
          data:
            selectedGateway?.url.indexOf("dynamicmanual") > -1
              ? {
                  amount: dataWithDefaultValues.amount,
                  slug: dataWithDefaultValues.slug,
                  dynamicFields: dataWithDefaultValues,
                }
              : dataWithDefaultValues,
          url: selectedGateway?.url,
          isMultiPart: selectedGateway?.fields.some(
            (f) => f?.type === "file" || f?.type === "image"
          ),
        });
        setIsCreatingDeposit(false);
        handleSubmitResponse(response);
      }
    } else {
      if (Object.values(validateBankFormData(formData)).length === 0) {
        setIsCreatingDeposit(true);
        createDeposit(formData)
          .then((res) => {
            setIsCreatingDeposit(false);
            Toaster(APP_CONST.TOAST_TYPE.SUCCESS, res.data.data.message);
          })
          .catch((err) => {
            setIsCreatingDeposit(false);
            Toaster(APP_CONST.TOAST_TYPE.ERROR, err.response.data.message);
          });
      }
    }
  };

  // Use useEffect to handle the logic of matching manual input with predefined amounts
  useEffect(() => {
    const matchedIndex = amountValues.indexOf(Number(dAmount));
    if (matchedIndex !== -1) {
      setActiveIndex(matchedIndex);
    } else if (dAmount !== null && dAmount !== "") {
      setActiveIndex(amountValues.length); // Special index for the input field
    } else {
      setActiveIndex(null);
    }
  }, [dAmount]);

  // Handle click outside to maintain active class on input click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (inputRef.current && !inputRef.current.contains(event.target)) {
        const matchedIndex = amountValues.indexOf(Number(dAmount));
        if (matchedIndex !== -1) {
          setActiveIndex(matchedIndex); // Match predefined value and set active index
        } else if (dAmount === "") {
          setActiveIndex(null); // Remove active class if input is empty
        }
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dAmount]);

  //TODO  Add it for url
  const handleSubmitResponse = (value) => {
    if (value) {
      if (
        selectedGateway?.url.indexOf("dynamicmanual") > -1 &&
        value?.data?.data
      ) {
        Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Request created");
        // navigate("/cashier");
        return;
      }
      if (selectedGateway.type === "manual") {
        Toaster(APP_CONST.TOAST_TYPE.SUCCESS, value.data.data.message);
      } else if (value?.data?.data?.data && "payUrl" in value?.data.data.data) {
        // Redirect url
        window.location.href = value?.data?.data?.data?.payUrl;
      } else if (
        value?.data?.data?.data &&
        "payImageUrl" in value?.data.data.data
      ) {
        // Show image
        setCustomActionDepositResponse(value?.data?.data?.data?.payImageUrl);
        setCustomDepositResponseType(CUSTOM_DEPOSIT_RESPONSE_TYPE.IMAGE);
      } else if (
        value?.data?.data?.data &&
        "qrContent" in value?.data.data.data
      ) {
        // Show qr code
        setCustomActionDepositResponse(value?.data?.data?.data?.qrContent);
        setCustomDepositResponseType(CUSTOM_DEPOSIT_RESPONSE_TYPE.QRCODE);
      } else if (value?.data?.data?.data && "url" in value?.data.data.data) {
        // Redirect url
        window.location.href = value?.data?.data?.data?.url;
      } else if (selectedGateway.code === "alphapo") {
        window.location.href = value?.data?.data?.data?.url;
      } else if (selectedGateway.code === "coinbase") {
        window.location.href = value?.data?.data?.data?.url;
      }
    }
  };

  const renderFields = (field) => {
    switch (field?.type) {
      case "file":
      case "image":
        return (
          <Form.Group
            className="mb-3 position-relative"
            controlId="formBasicUserName"
            key={field?.accessor}
          >
            <Form.Control
              type={"file"}
              placeholder={field?.label}
              name={field?.accessor}
              onChange={(e) => handleChange(e, "file")}
              style={{ display: !field?.display ? "none" : "" }}
              isInvalid={!!errors?.[field?.accessor]}
            />
            <span className="focus-border">
              <i></i>
            </span>
            <Form.Control.Feedback type="invalid">
              {errors?.[field?.accessor]}
            </Form.Control.Feedback>
          </Form.Group>
        );
      default:
        return (
          <>
            <Form.Group
              className="mb-3 position-relative"
              controlId="formBasicUserName "
              key={field?.accessor}
            >
              <Form.Control
                type={field?.type}
                value={
                  !Boolean(formData?.[field?.accessor]) &&
                  formData?.[field?.accessor] !== "" &&
                  field?.value
                    ? field?.value
                    : formData?.[field?.accessor] || ""
                }
                placeholder={field?.label}
                name={field?.accessor}
                onChange={(e) => handleChange(e, "non-file", field?.type)}
                style={{ display: !field?.display ? "none" : "" }}
                isInvalid={!!errors?.[field?.accessor]}
              />
              <span className="focus-border">
                <i></i>
              </span>
              <Form.Control.Feedback type="invalid">
                {errors?.[field?.accessor]}
              </Form.Control.Feedback>
            </Form.Group>
          </>
        );
    }
  };

  const renderBankTransferForm = () => {
    return (
      <Form className="gatewayForm">
        <Form.Group
          className="mb-3 position-relative"
          controlId="formBasicUserName"
        >
          <Form.Control
            type={"number"}
            placeholder={"Enter amount"}
            name={"amount"}
            onChange={(e) => handleChange(e)}
            // style={{ display: !field.display ? "none" : "" }}
            isInvalid={!!errors["amount"]}
          />
          <span className="focus-border">
            <i></i>
          </span>
          <Form.Control.Feedback type="invalid">
            {errors["amount"]}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group
          className="mb-3 position-relative"
          controlId="formBasicUserName"
        >
          <Form.Control
            type={"text"}
            placeholder={"Enter UTR no"}
            name={"utrNo"}
            onChange={(e) => handleChange(e)}
            // style={{ display: !field.display ? "none" : "" }}
            isInvalid={!!errors["utrNo"]}
          />
          <span className="focus-border">
            <i></i>
          </span>
          <Form.Control.Feedback type="invalid">
            {errors["utrNo"]}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group
          className="mb-3 position-relative"
          controlId="formBasicUserName"
        >
          <Form.Control
            type={"file"}
            placeholder={"Select file"}
            name={"txnImage"}
            onChange={(e) => handleChange(e, "file")}
            // style={{ display: !field.display ? "none" : "" }}
            isInvalid={!!errors["txnImage"]}
          />
          <span className="focus-border">
            <i></i>
          </span>
          <Form.Control.Feedback type="invalid">
            {errors["txnImage"]}
          </Form.Control.Feedback>
        </Form.Group>
        <div className="d-flex">
          <Button
            className="px-5 mb-4"
            variant="primary"
            onClick={handleSubmit}
            style={{ fontSize: "15px", borderRadius: "3px" }}
            disabled={loading}
          >
            {loading ? "Loading.." : "Submit"}
          </Button>
          <Button
            onClick={() => navigate("/deposit-list")}
            className="px-4 mb-4"
            style={{ marginLeft: "2px" }}
          >
            View Request
          </Button>
        </div>
      </Form>
    );
  };

  const renderCustomActionResponse = () => {
    if (customdepositResponseType === CUSTOM_DEPOSIT_RESPONSE_TYPE.IMAGE) {
      return (
        <div>
          <div className="ml-4 ">
            <div className="bg-zinc-50 rounded-lg p-3 qrSize">
              <img src={customActionDepositResponse} />
            </div>
          </div>
        </div>
      );
    } else if (
      customdepositResponseType === CUSTOM_DEPOSIT_RESPONSE_TYPE.QRCODE
    ) {
      return (
        <div>
          <QRCodeCard text={customActionDepositResponse} />
        </div>
      );
    } else {
      return null;
    }
  };

  return (
    <>
      <HeaderAfterLogin />

      {customActionDepositResponse && customdepositResponseType ? (
        <>
          <div className="HpaySection">
            <div
              className="HayQR"
              onClick={() => {
                setCustomActionDepositResponse(null);
                setCustomDepositResponseType(null);
              }}
            >
              <img src={CrossBtn} alt="CrossBtn" />
            </div>
            {renderCustomActionResponse()}
          </div>
        </>
      ) : (
        <main className="main">
          <div className="main-page">
            <LeftBarSports />

            <div className="main-content">
              {!isBank ? (
                <Container fluid>
                  <div className="headingSec">
                    <div className="back-link" onClick={() => navigate(-1)}>
                      <img src={LeftArrow} alt="LeftArrow" />{" "}
                      <h1>{selectedGateway?.name}</h1>
                    </div>
                  </div>
                  <DisplayValues
                    displayItems={selectedGateway?.depositDisplayFields || []}
                  />
                  {selectedGateway?.type === "manual" &&
                    selectedGateway?.url !== "/deposit/pay/dynamicmanual" && (
                      <>
                        <div className="valuesDeposit">
                          {/* <h3>Wallet : {selectedGateway?.value}</h3> */}
                          <h3>UPI : {selectedGateway?.displayValue}</h3>

                          <div className="copyValue">
                            <CopyToClipboard
                              text={selectedGateway?.displayValue}
                              onCopy={() => {
                                Toaster(
                                  APP_CONST.TOAST_TYPE.SUCCESS,
                                  "Text Copied"
                                );
                              }}
                            >
                              <AiFillCopy />
                            </CopyToClipboard>

                            <div>Click to copy code</div>
                          </div>
                        </div>
                        {(selectedGateway?.showQr === true && (
                          <div className="d-flex">
                            {showQrImg ? (
                              <div className=" mx-auto  w-full max-w-[12rem]  relative">
                                <div className="ml-4 ">
                                  <div className="bg-zinc-50 rounded-lg p-3 qrSize">
                                    <img src={selectedGateway?.qrCode} />
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <QRCodeCard text={selectedGateway?.value} />
                            )}
                          </div>
                        )) ||
                          null}
                      </>
                    )}
                  <Form className="gatewayForm mb-4">
                    {selectedGateway?.fields?.map((f, i) => {
                      return renderFields(f);
                    })}

                    <div className="d-flex">
                      <Button
                        className={
                          selectedGateway?.type === "auto"
                            ? "next-btn"
                            : "px-4 mb-4"
                        }
                        onClick={handleSubmit}
                        style={{ fontSize: "15px", borderRadius: "3px" }}
                        disabled={loading}
                      >
                        {loading ? "Loading.." : "Submit"}
                      </Button>
                      {(selectedGateway?.type === "manual" && (
                        <Button
                          onClick={() => navigate("/deposit-list")}
                          className="px-4 mb-4"
                          style={{ marginLeft: "2px" }}
                        >
                          View Request
                        </Button>
                      )) ||
                        null}
                    </div>
                  </Form>
                </Container>
              ) : (
                <Container fluid>
                  <div className="headingSec">
                    <div className="back-link" onClick={() => navigate(-1)}>
                      <img src={LeftArrow} alt="LeftArrow" />{" "}
                      <h1> {"Bank Transfer"}</h1>
                    </div>
                  </div>

                  {bankDetails && (
                    <div
                      className="mb-4"
                      style={{
                        background: "#fff",
                        color: "#111",
                        padding: "15px",
                        borderRadius: "5px",
                      }}
                    >
                      <p>
                        Account name : {bankDetails?.acc_name}{" "}
                        <CopyToClipboard
                          text={bankDetails?.acc_name}
                          onCopy={() => {
                            Toaster(
                              APP_CONST.TOAST_TYPE.SUCCESS,
                              "Text Copied"
                            );
                          }}
                        >
                          <AiFillCopy />
                        </CopyToClipboard>
                        {/* <CopyToClipboard
                    text={bankDetails?.acc_name}
                    onCopy={() => {
                      Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Text Copied");
                      console.log("Abc");
                    }}
                  /> */}
                      </p>
                      <p>
                        Account number : {bankDetails?.acc_no}{" "}
                        <CopyToClipboard
                          text={bankDetails?.acc_no}
                          onCopy={() => {
                            Toaster(
                              APP_CONST.TOAST_TYPE.SUCCESS,
                              "Text Copied"
                            );
                          }}
                        >
                          <AiFillCopy />
                        </CopyToClipboard>
                        {/* <CopyToClipboard
                    text={bankDetails?.acc_no}
                    onCopy={() => {
                      Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Text Copied");
                    }}
                  /> */}
                      </p>
                      <p>
                        IFSC code : {bankDetails?.ifsc_code}{" "}
                        <CopyToClipboard
                          text={bankDetails?.ifsc_code}
                          onCopy={() => {
                            Toaster(
                              APP_CONST.TOAST_TYPE.SUCCESS,
                              "Text Copied"
                            );
                          }}
                        >
                          <AiFillCopy />
                        </CopyToClipboard>
                        {/* <CopyToClipboard
                    text={bankDetails?.ifsc_code}
                    onCopy={() => {
                      Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Text Copied");
                    }}
                  /> */}
                      </p>
                      <p className="mb-0">
                        Bank name : {bankDetails?.bank_name}{" "}
                        <CopyToClipboard
                          text={bankDetails?.bank_name}
                          onCopy={() => {
                            Toaster(
                              APP_CONST.TOAST_TYPE.SUCCESS,
                              "Text Copied"
                            );
                          }}
                        >
                          <AiFillCopy />
                        </CopyToClipboard>
                        {/* <CopyToClipboard
                    text={bankDetails?.bank_name}
                    onCopy={() => {
                      Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Text Copied");
                    }}
                  /> */}
                      </p>
                    </div>
                  )}
                  {bankDetails && renderBankTransferForm()}
                </Container>
              )}
              <Footer />
            </div>
          </div>
        </main>
      )}

      <WhatsAppWidget />
    </>
  );
};
export default DepositGateway;
